import WhatIsNewModalContainer from './containers/WhatIsNewModalContainer'

export default WhatIsNewModalContainer
